<template>
  <div class="trigger-status-editor">
    <!-- Node Intro -->
    <div class="node-intro">
      <div class="node-icon">
        <!-- Order Update Icon -->
        <svg v-if="triggerType === 'orderUpdate'" preserveAspectRatio="none" width="100%" height="100%" overflow="visible" style="display: block;" viewBox="0 0 17 17" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M12.125 9.16667C12.75 9.16667 13.3 8.825 13.5833 8.30833L16.5667 2.9C16.875 2.35 16.475 1.66667 15.8417 1.66667H3.50833L2.725 0H0V1.66667H1.66667L4.66667 7.99167L3.54167 10.025C2.93333 11.1417 3.73333 12.5 5 12.5H15V10.8333H5L5.91667 9.16667H12.125ZM4.3 3.33333H14.425L12.125 7.5H6.275L4.3 3.33333ZM5 13.3333C4.08333 13.3333 3.34167 14.0833 3.34167 15C3.34167 15.9167 4.08333 16.6667 5 16.6667C5.91667 16.6667 6.66667 15.9167 6.66667 15C6.66667 14.0833 5.91667 13.3333 5 13.3333ZM13.3333 13.3333C12.4167 13.3333 11.675 14.0833 11.675 15C11.675 15.9167 12.4167 16.6667 13.3333 16.6667C14.25 16.6667 15 15.9167 15 15C15 14.0833 14.25 13.3333 13.3333 13.3333Z" fill="#20a7c1"/>
        </svg>
        
        <!-- Appointment Update Icon -->
        <svg v-else-if="triggerType === 'appointmentUpdate'" preserveAspectRatio="none" width="100%" height="100%" overflow="visible" style="display: block;" viewBox="0 0 15 17" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M13.3333 1.66667H12.5V0H10.8333V1.66667H4.16667V0H2.5V1.66667H1.66667C0.741667 1.66667 0.00833333 2.41667 0.00833333 3.33333L0 15C0 15.9167 0.741667 16.6667 1.66667 16.6667H13.3333C14.25 16.6667 15 15.9167 15 15V3.33333C15 2.41667 14.25 1.66667 13.3333 1.66667ZM13.3333 15H1.66667V6.66667H13.3333V15ZM13.3333 5H1.66667V3.33333H13.3333V5ZM7.5 9.16667H11.6667V13.3333H7.5V9.16667Z" fill="#20a7c1"/>
        </svg>
        
        <!-- Document Update Icon -->
        <svg v-else-if="triggerType === 'documentUpdate'" preserveAspectRatio="none" width="100%" height="100%" overflow="visible" style="display: block;" viewBox="0 0 14 17" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M3.33333 11.6667H10V13.3333H3.33333V11.6667ZM3.33333 8.33333H10V10H3.33333V8.33333ZM8.33333 0H1.66667C0.75 0 0 0.75 0 1.66667V15C0 15.9167 0.741666 16.6667 1.65833 16.6667H11.6667C12.5833 16.6667 13.3333 15.9167 13.3333 15V5L8.33333 0ZM11.6667 15H1.66667V1.66667H7.5V5.83333H11.6667V15Z" fill="#20a7c1"/>
        </svg>
        
        <!-- Report Update Icon -->
        <svg v-else-if="triggerType === 'reportUpdate'" preserveAspectRatio="none" width="100%" height="100%" overflow="visible" style="display: block;" viewBox="0 0 15 17" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M3.33333 11.6667H9.16667V13.3333H3.33333V11.6667ZM3.33333 8.33333H11.6667V10H3.33333V8.33333ZM3.33333 5H11.6667V6.66667H3.33333V5ZM13.3333 1.66667H9.85C9.5 0.7 8.58333 0 7.5 0C6.41667 0 5.5 0.7 5.15 1.66667H1.66667C1.55 1.66667 1.44167 1.675 1.33333 1.7C1.00833 1.76667 0.716667 1.93333 0.491667 2.15833C0.341667 2.30833 0.216667 2.49167 0.133333 2.69167C0.0500001 2.88333 0 3.1 0 3.33333V15C0 15.225 0.0500001 15.45 0.133333 15.65C0.216667 15.85 0.341667 16.025 0.491667 16.1833C0.716667 16.4083 1.00833 16.575 1.33333 16.6417C1.44167 16.6583 1.55 16.6667 1.66667 16.6667H13.3333C14.25 16.6667 15 15.9167 15 15V3.33333C15 2.41667 14.25 1.66667 13.3333 1.66667ZM7.5 1.45833C7.84167 1.45833 8.125 1.74167 8.125 2.08333C8.125 2.425 7.84167 2.70833 7.5 2.70833C7.15833 2.70833 6.875 2.425 6.875 2.08333C6.875 1.74167 7.15833 1.45833 7.5 1.45833ZM13.3333 15H1.66667V3.33333H13.3333V15Z" fill="#20a7c1"/>
        </svg>
        
        <!-- Task Update Icon -->
        <svg v-else-if="triggerType === 'taskUpdate'" preserveAspectRatio="none" width="100%" height="100%" overflow="visible" style="display: block;" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M8 17C8.28333 17 8.52083 16.9042 8.7125 16.7125C8.90417 16.5208 9 16.2833 9 16C9 15.7167 8.90417 15.4792 8.7125 15.2875C8.52083 15.0958 8.28333 15 8 15C7.71667 15 7.47917 15.0958 7.2875 15.2875C7.09583 15.4792 7 15.7167 7 16C7 16.2833 7.09583 16.5208 7.2875 16.7125C7.47917 16.9042 7.71667 17 8 17ZM8 13C8.28333 13 8.52083 12.9042 8.7125 12.7125C8.90417 12.5208 9 12.2833 9 12C9 11.7167 8.90417 11.4792 8.7125 11.2875C8.52083 11.0958 8.28333 11 8 11C7.71667 11 7.47917 11.0958 7.2875 11.2875C7.09583 11.4792 7 11.7167 7 12C7 12.2833 7.09583 12.5208 7.2875 12.7125C7.47917 12.9042 7.71667 13 8 13ZM8 9C8.28333 9 8.52083 8.90417 8.7125 8.7125C8.90417 8.52083 9 8.28333 9 8C9 7.71667 8.90417 7.47917 8.7125 7.2875C8.52083 7.09583 8.28333 7 8 7C7.71667 7 7.47917 7.09583 7.2875 7.2875C7.09583 7.47917 7 7.71667 7 8C7 8.28333 7.09583 8.52083 7.2875 8.7125C7.47917 8.90417 7.71667 9 8 9ZM11 17H17V15H11V17ZM11 13H17V11H11V13ZM11 9H17V7H11V9ZM5 21C4.45 21 3.97917 20.8042 3.5875 20.4125C3.19583 20.0208 3 19.55 3 19V5C3 4.45 3.19583 3.97917 3.5875 3.5875C3.97917 3.19583 4.45 3 5 3H19C19.55 3 20.0208 3.19583 20.4125 3.5875C20.8042 3.97917 21 4.45 21 5V19C21 19.55 20.8042 20.0208 20.4125 20.4125C20.0208 20.8042 19.55 21 19 21H5ZM5 19H19V5H5V19Z" fill="#20a7c1"/>
        </svg>
        
        <!-- Profile Update Icon -->
        <svg v-else-if="triggerType === 'profileUpdate'" preserveAspectRatio="none" width="100%" height="100%" overflow="visible" style="display: block;" viewBox="0 0 17 17" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M8.33333 0C3.73333 0 0 3.73333 0 8.33333C0 12.9333 3.73333 16.6667 8.33333 16.6667C12.9333 16.6667 16.6667 12.9333 16.6667 8.33333C16.6667 3.73333 12.9333 0 8.33333 0ZM4.225 13.5667C4.58333 12.8167 6.76667 12.0833 8.33333 12.0833C9.9 12.0833 12.0917 12.8167 12.4417 13.5667C11.3083 14.4667 9.88333 15 8.33333 15C6.78333 15 5.35833 14.4667 4.225 13.5667ZM13.6333 12.3583C12.4417 10.9083 9.55 10.4167 8.33333 10.4167C7.11667 10.4167 4.225 10.9083 3.03333 12.3583C2.18333 11.2417 1.66667 9.85 1.66667 8.33333C1.66667 4.65833 4.65833 1.66667 8.33333 1.66667C12.0083 1.66667 15 4.65833 15 8.33333C15 9.85 14.4833 11.2417 13.6333 12.3583ZM8.33333 3.33333C6.71667 3.33333 5.41667 4.63333 5.41667 6.25C5.41667 7.86667 6.71667 9.16667 8.33333 9.16667C9.95 9.16667 11.25 7.86667 11.25 6.25C11.25 4.63333 9.95 3.33333 8.33333 3.33333ZM8.33333 7.5C7.64167 7.5 7.08333 6.94167 7.08333 6.25C7.08333 5.55833 7.64167 5 8.33333 5C9.025 5 9.58333 5.55833 9.58333 6.25C9.58333 6.94167 9.025 7.5 8.33333 7.5Z" fill="#20a7c1"/>
        </svg>
      </div>
      <p class="node-description">
        <span class="node-title">{{ config.title }}</span> triggers when {{ config.description }}
      </p>
    </div>

    <!-- Property Content -->
    <div class="property-content">
      <p class="property-label">Select Event to monitor:</p>
      <div class="options-list">
        <div
          v-for="(option, index) in config.events"
          :key="index"
          class="option-item"
        >
          <Checkbox
            :modelValue="selectedEvents.includes(option)"
            built_in_theme="dark"
            size="medium"
            @update:modelValue="toggleEvent(option)"
          />
          <span class="option-label">{{ option }}</span>
        </div>
      </div>
    </div>

    <!-- Save Configuration Button -->
    <button class="save-config-btn" :disabled="isSaveDisabled" @click="saveConfiguration">
      <svg class="btn-icon" width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M9.59016 13C10.1402 13 10.5902 13.45 10.5902 14C10.5902 14.55 10.1402 15 9.59016 15C9.04016 15 8.59016 14.55 8.59016 14C8.59016 13.45 9.04016 13 9.59016 13ZM9.59016 11C7.93016 11 6.59016 12.34 6.59016 14C6.59016 15.66 7.93016 17 9.59016 17C11.2502 17 12.5902 15.66 12.5902 14C12.5902 12.34 11.2502 11 9.59016 11ZM18.0902 9L19.1802 6.59L21.5902 5.5L19.1802 4.41L18.0902 2L17.0002 4.41L14.5902 5.5L17.0002 6.59L18.0902 9ZM20.8702 12.72L20.0902 11L19.3102 12.72L17.5902 13.5L19.3102 14.28L20.0902 16L20.8702 14.28L22.5902 13.5L20.8702 12.72ZM15.8402 14C15.8402 13.88 15.8402 13.75 15.8302 13.63L17.7702 12.16L15.2702 7.83L13.0302 8.77C12.8302 8.64 12.6102 8.51 12.3902 8.4L12.0902 6H7.09016L6.79016 8.41C6.57016 8.52 6.36016 8.65 6.15016 8.78L3.91016 7.83L1.41016 12.16L3.35016 13.63C3.34016 13.75 3.34016 13.88 3.34016 14C3.34016 14.12 3.34016 14.25 3.35016 14.37L1.41016 15.84L3.91016 20.17L6.15016 19.23C6.35016 19.36 6.57016 19.49 6.79016 19.6L7.09016 22H12.0902L12.3902 19.59C12.6102 19.48 12.8202 19.36 13.0302 19.22L15.2702 20.16L17.7702 15.83L15.8302 14.36C15.8402 14.25 15.8402 14.12 15.8402 14ZM14.4202 17.64L12.6902 16.91C12.1302 17.51 11.3902 17.95 10.5602 18.14L10.3202 20H8.86016L8.63016 18.14C7.80016 17.95 7.06016 17.51 6.50016 16.91L4.77016 17.64L4.04016 16.37L5.53016 15.24C5.41016 14.85 5.35016 14.44 5.35016 14.01C5.35016 13.58 5.41016 13.17 5.53016 12.78L4.04016 11.65L4.77016 10.38L6.50016 11.11C7.06016 10.51 7.80016 10.07 8.63016 9.88L8.86016 8H10.3302L10.5602 9.86C11.3902 10.05 12.1302 10.49 12.6902 11.09L14.4202 10.36L15.1502 11.63L13.6602 12.76C13.7802 13.15 13.8402 13.56 13.8402 13.99C13.8402 14.42 13.7802 14.83 13.6602 15.22L15.1502 16.35L14.4202 17.64Z" fill="white"/>
      </svg>
      <span>Save Configuration</span>
    </button>
  </div>
</template>

<script>
export default {
  name: 'TriggerStatusUpdateEditor',
  props: {
    triggerType: {
      type: String,
      required: true,
      validator: (value) => ['orderUpdate', 'appointmentUpdate', 'documentUpdate', 'reportUpdate', 'taskUpdate', 'profileUpdate'].includes(value)
    },
    initialEvents: {
      type: Array,
      default: () => []
    },
    data: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      selectedEvents: [...this.initialEvents],
      triggerConfigs: {
        orderUpdate: {
          title: 'Order Update',
          description: 'order status changes occur in your system.',
          events: [
            'Order Created',
            'Order Modified',
            'Order Redrawn',
            'Payment Complete',
            'Payment Failed',
            'Payment Refund',
            'Lab Shipped',
            'Test Not Performed',
            'Order Canceled'
          ]
        },
        appointmentUpdate: {
          title: 'Appointment Update',
          description: 'calendar appointment status changes occur.',
          events: [
            'Appointment Created',
            'Appointment Accepted',
            'Appointment Rejected',
            'Appointment Tentative',
            'Appointment Canceled'
          ]
        },
        documentUpdate: {
          title: 'Document/Form Update',
          description: 'a document or form interaction occurs.',
          events: [
            'Form Submitted'
          ]
        },
        reportUpdate: {
          title: 'Report Update',
          description: 'a report status changes.',
          events: [
            'Report Available',
            'Report Shared'
          ]
        },
        taskUpdate: {
          title: 'Task Update',
          description: 'a task status changes.',
          events: [
            'Task Open',
            'Task Completed'
          ]
        },
        profileUpdate: {
          title: 'Internal Note Status Update',
          description: 'a patient profile or note is changed.',
          events: [
            'Internal Note Created',
            'Internal Note Update'
          ]
        }
      }
    };
  },
  computed: {
    config() {
      return this.triggerConfigs[this.triggerType] || this.triggerConfigs.orderUpdate;
    },
    isSaveDisabled() {
      return this.selectedEvents.length === 0;
    }
  },
  watch: {
    initialEvents: {
      handler(newVal) {
        this.selectedEvents = newVal ? [...newVal] : [];
      },
      immediate: true,
      deep: true
    }
  },
  methods: {
    toggleEvent(option) {
      const index = this.selectedEvents.indexOf(option);
      if (index > -1) {
        this.selectedEvents.splice(index, 1);
      } else {
        this.selectedEvents.push(option);
      }
    },
    saveConfiguration() {
      this.$emit('save', {
        subtype: this.data.subtype,
        events: this.selectedEvents,
        configured: this.selectedEvents.length > 0
      });
    }
  }
};
</script>

<style scoped>
.trigger-status-editor {
  display: flex;
  flex-direction: column;
  gap: 16px;
  width: 100%;
}

/* Node Intro */
.node-intro {
  display: flex;
  gap: 8px;
  align-items: flex-start;
  padding: 8px 12px;
  background: #E5F9EF;
  border-radius: 5px;
}

.node-icon {
  width: 24px;
  height: 24px;
  flex-shrink: 0;
  display: flex;
  align-items: center;
  justify-content: center;
}

.node-description {
  flex: 1;
  font-family: 'Inter', sans-serif;
  font-size: 14px;
  font-weight: 300;
  line-height: 18px;
  color: #20A7C1;
  margin: 0;
}

.node-title {
  font-weight: 700;
}

/* Property Content */
.property-content {
  display: flex;
  flex-direction: column;
  gap: 10px;
  padding: 0 8px;
}

.property-label {
  font-family: 'Inter', sans-serif;
  font-size: 16px;
  font-weight: 500;
  line-height: 24px;
  letter-spacing: 0.15px;
  color: #333;
  margin: 0;
}

.options-list {
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.option-item {
  display: flex;
  gap: 8px;
  align-items: center;
  padding-left: 16px;
}

.option-label {
  font-family: 'Inter', sans-serif;
  font-size: 14px;
  font-weight: 400;
  line-height: 20px;
  letter-spacing: 0.25px;
  color: #333;
}

/* Save Configuration Button */
.save-config-btn {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 4px;
  height: 32px;
  padding: 4px 8px;
  background: #004879;
  border: none;
  border-radius: 4px;
  box-shadow: 0px 1px 3px 0px rgba(74, 74, 74, 0.25);
  font-family: 'Inter', sans-serif;
  font-size: 14px;
  font-weight: 500;
  line-height: 20px;
  letter-spacing: 0.1px;
  color: #FFFFFF;
  cursor: pointer;
  transition: background 0.2s;
}

.save-config-btn:hover:not(:disabled) {
  background: #003366;
}

.save-config-btn:disabled {
  background: #9CA3AF;
  cursor: not-allowed;
  opacity: 0.6;
}

.btn-icon {
  font-size: 24px;
  color: white;
}


</style>
